// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"19af67b6","389":"19c134ba","732":"68c9dcbb","977":"024e8720"}[chunkId] + ".chunk.js";
};